import React from "react";
import HttpsRedirect from "react-https-redirect";
import { GoogleOAuthProvider } from "@react-oauth/google";
import { Toaster } from "react-hot-toast";
import { Routes, Route, Navigate } from "react-router-dom";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Login, { SignIn, LostPassword, LoginLayout } from "pages/Login/Login";
import Logout from "pages/Logout/Logout";

import { StudentSignUp } from "pages/SignUp";
import FindEmail from "pages/FindEmail/FindEmail";
import Error404 from "components/Error404/Error404";
import TIA from "components/TIA/TIA";
import { getSupportUrl } from "utils/getSupportUrl";
import { getSiteOptions } from "utils/getSiteOptions";
import RedirectSessionProvider from "context/RedirectSessionProvider";
import { Healthcheck } from "pages/Healthcheck/Healthcheck";

function App() {
  const appName = process.env.REACT_APP_NAME;
  const siteOptions = getSiteOptions(appName);

  return (
    <GoogleOAuthProvider
      clientId={process.env.REACT_APP_GOOGLE_CLIENT_ID || ""}
    >
      <HttpsRedirect>
        <Toaster position="top-center" reverseOrder={false} />
        <TIA
          message={
            <span>
              Precisa de ajuda?
              <br />
              <a
                href={getSupportUrl()}
                target="_blank"
                rel="noopener noreferrer"
              >
                Clique aqui
              </a>
            </span>
          }
        />

        <HelmetProvider>
          <Helmet>
            <title>{siteOptions.title}</title>
            <body className={appName} />
            <meta charset="utf-8" />
            <meta name="description" content={siteOptions.description} />
            <meta property="og:image" content={siteOptions.ogImage} />
            <link rel="icon" href={siteOptions.favicon} type="image/png" />
          </Helmet>

          <Routes>
            <Route element={<RedirectSessionProvider />}>
              <Route path="/" element={<Navigate to="/login" replace />} />
              <Route path="login">
                <Route index element={<Login />} />
                <Route path=":link/:connection" element={<Login />} />
              </Route>
              <Route path="entrar">
                <Route index element={<SignIn />} />
                <Route path=":link/:connection" element={<SignIn />} />
              </Route>
            </Route>
            <Route path="logout" element={<Logout />} />
            <Route path="esqueci-a-senha" element={<LostPassword />} />

            <Route path="criar-uma-conta">
              <Route path="aluno">
                <Route index element={<StudentSignUp />} />
                <Route path=":formStep" element={<StudentSignUp />} />
                <Route
                  path=":link/:connection/:formStep"
                  element={<StudentSignUp />}
                />
              </Route>
              <Route index element={<StudentSignUp />} />
              <Route path=":formStep" element={<StudentSignUp />} />
              <Route
                path=":link/:connection/:formStep"
                element={<StudentSignUp />}
              />
            </Route>
            <Route path="consultar-email">
              <Route index element={<FindEmail />} />
              <Route path=":step" element={<FindEmail />} />
            </Route>
            <Route path="healthcheck" element={<Healthcheck />} />
            <Route path="*" element={<Error404 />} />
          </Routes>
        </HelmetProvider>
      </HttpsRedirect>
    </GoogleOAuthProvider>
  );
}

export default App;
